import React from "react";
import TimelineList from "lib/components/Timeline/TimelineList/TimelineList";

import { PrimaryButton } from "lib/components/Buttons/buttons.jsx";
import styles from "../../../pages/Events/Events.module.scss";
import { TimelineItemMinimal } from ".";

export const DisplayEventsMinimal = ({
  events,
  handleMoreEvents = () => {},
  hasMore = false,
}) => {
  const renderTimelineItems = events.map((event) => (
    <TimelineItemMinimal key={event.id} event={event} />
  ));

  return (
    <div>
      <TimelineList>{renderTimelineItems}</TimelineList>
      {hasMore && (
        <div className={styles.loadMoreButton}>
          <PrimaryButton onClick={handleMoreEvents}>
            Încarcă mai multe
          </PrimaryButton>
        </div>
      )}
    </div>
  );
};
